import {Chromeless} from '@freckle/classroom/ts/hooks/chromeless/component'
import {LoggedRoute} from './../../logged-route'
import {
  ArticlesComponentContainer,
  AssignDecodablePage,
  ElaArticleDescriptionHandler,
  ElaAssignArticleComponentContainer,
  ElaAssignAssessmentHandler,
  ElaAssignSkillPracticeHandler,
  ChromelessElaAssignSkillPracticeHandler,
  ElaAssignWordStudyHandler,
  ElaAssignmentsHandler,
  ElaFocusSkillsPracticeAssignmentsHandler
} from './lazy'

export const routerV2ElaAssign = [
  {
    path: '/ela/assignments',
    element: <LoggedRoute component={ElaAssignmentsHandler} />
  },
  {
    path: '/ela/targeted-skill-practice/assign',
    element: <LoggedRoute component={ElaAssignSkillPracticeHandler} />
  },
  {
    path: '/chromeless/ela/targeted-skill-practice/assign',
    element: (
      <Chromeless>
        <LoggedRoute
          dashboardType="minimal"
          fullScreen
          component={ChromelessElaAssignSkillPracticeHandler}
        />
      </Chromeless>
    )
  },
  {
    path: '/ela/articles/:articleUuid/assign',
    element: <LoggedRoute component={ElaAssignArticleComponentContainer} />
  },
  {
    path: '/ela/assessments',
    element: <LoggedRoute component={ElaAssignAssessmentHandler} />
  },
  {
    path: '/ela/word-study',
    element: <LoggedRoute component={ElaAssignWordStudyHandler} />
  },
  {
    path: '/ela/decodable/assign',
    element: <LoggedRoute component={AssignDecodablePage} />
  },
  {
    path: '/ela/articles',
    element: <LoggedRoute component={ArticlesComponentContainer} />
  },
  {
    path: '/ela/articles/:articleUuid',
    element: <LoggedRoute component={ElaArticleDescriptionHandler} />
  },
  {
    path: '/assignments/ela-focus-skills-practice',
    element: <LoggedRoute component={ElaFocusSkillsPracticeAssignmentsHandler} />
  }
]
